import type { Selection } from '@atlaskit/editor-prosemirror/state';

const TAB_CONFLICT_NODE_TYPES = new Set(['table', 'expand', 'caption', 'codeBlock']);

/**
 * Check whether the Tab key is already claimed by another plugin
 * in the current editor context.
 *
 * Walks the ancestor nodes of the current selection and checks
 * whether any of them are node types known to handle the Tab key
 * (e.g. tables, code blocks).
 *
 * Initially, I want to use view.someProp('handleKeyDown', ...) to dynamically iterate
 * all registered plugins' key handlers and check if any would handle a Tab keypress.
 * (Still need static checking as a fallback because plugins can listen to keyboard events directly)
 * But handlers could cause side-effects by update editor state or external state.
 * So only use static checking for now.
 */
export function hasTabConflict(selection: Selection): boolean {
	const { $from } = selection;
	for (let depth = $from.depth; depth > 0; depth--) {
		const ancestorTypeName = $from.node(depth).type.name;
		if (TAB_CONFLICT_NODE_TYPES.has(ancestorTypeName)) {
			return true;
		}
	}

	return false;
}
